var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"track"},[_c('div',{staticClass:"item"},[_vm._v("汉")]),_c('div',{staticClass:"item"},[_vm._v("ئۇ")]),_c('div',{staticClass:"indicator",class:{'on':_vm.rtl}},[_vm._v(_vm._s(_vm.indicatorText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }